// Which sections of a crosslink relation's two members are drawn together. Pure, so
// the node tests pin the rules the hover has always used; the member hover in the
// sidebar uses them too (with no cursor, so every range).

/**
 * @typedef {{startCm: number, endCm: number}} Range
 * @param {Range[]} hoveredRanges the hovered member's role ranges
 * @param {Range[]} otherRanges the other member's role ranges
 * @param {number} cursorIndex the hovered range under the cursor, or -1
 * @returns {{hovered: Range[], other: Range[]}} `[]` means the whole geometry
 */
export function pairCrosslinkRanges(hoveredRanges, otherRanges, cursorIndex) {
  let other;
  if (otherRanges.length === 0) {
    other = []; // no decodable range → whole geometry
  } else if (otherRanges.length === 1) {
    other = otherRanges;
  } else if (cursorIndex >= 0 && cursorIndex < otherRanges.length) {
    // The hovered member's range index maps to the same index on the other one.
    other = [otherRanges[cursorIndex]];
  } else {
    other = otherRanges; // can't pair → fall back to all sections
  }
  const hovered =
    cursorIndex >= 0 ? [hoveredRanges[cursorIndex]] : hoveredRanges;
  return { hovered, other };
}

/**
 * Whether any range ends past the member's own length — the relation is then
 * out-of-bounds on that member. Open-ended ranges (Infinity end) mean "till the
 * end of the segment" by design, so they don't count.
 */
export function rangesOvershoot(ranges, lengthCm) {
  return (
    lengthCm > 0 &&
    ranges.some(
      (range) => Number.isFinite(range.endCm) && range.endCm > lengthCm,
    )
  );
}
